"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    button: function button(_ref2) {
      var color = _ref2.color,
          bgColor = _ref2.bgColor,
          hoverColor = _ref2.hoverColor,
          hoverBgColor = _ref2.hoverBgColor,
          border = _ref2.border,
          borderColor = _ref2.borderColor,
          borderSize = _ref2.borderSize,
          otherProps = (0, _objectWithoutProperties2["default"])(_ref2, ["color", "bgColor", "hoverColor", "hoverBgColor", "border", "borderColor", "borderSize"]);
      return _objectSpread({
        fontSize: 16,
        fontWeight: 'normal',
        padding: "0 ".concat(spacing(1), "px"),
        color: (0, _ramda.or)(color, palette.link.main),
        backgroundColor: (0, _ramda.or)(bgColor, palette.common.white),
        border: border || "".concat(borderSize, "px solid ").concat(borderColor || color || palette.link.main),
        '&:hover': {
          color: (0, _ramda.or)(hoverColor, palette.link.main),
          backgroundColor: (0, _ramda.or)(hoverBgColor, palette.common.white)
        },
        '&:disabled': {
          color: palette.grey.main,
          backgroundColor: palette.background["default"],
          border: 'none'
        }
      }, otherProps);
    }
  };
});
/**
 * BaseButton. Based on configured Material-UI button.
 *
 * @deprecated
 *
 * @param {object} props
 * @param {number} [props.width=100]
 * @param {number} [props.height=48]
 * @param {string} [props.color='']
 * @param {string} [props.bgColor='']
 * @param {string} [props.hoverColor='']
 * @param {string} [props.hoverBgColor='']
 * @param {React.ReactNode} [props.children='']
 * @param {string} [props.borderColor='']
 * @param {string} [props.border=undefined]
 * @param {number} [props.borderSize=1]
 * @param {number} [props.minHeight=undefined]
 * @param {number} [props.lineHeight=undefined]
 * @param {string} [props.overrideClass='']
 * @returns {React.ReactElement}
 *
 * @example
 * //TODO: write example
 */

var BaseButton = function BaseButton(_ref3) {
  var width = _ref3.width,
      height = _ref3.height,
      color = _ref3.color,
      bgColor = _ref3.bgColor,
      hoverColor = _ref3.hoverColor,
      hoverBgColor = _ref3.hoverBgColor,
      children = _ref3.children,
      borderColor = _ref3.borderColor,
      border = _ref3.border,
      borderSize = _ref3.borderSize,
      minHeight = _ref3.minHeight,
      lineHeight = _ref3.lineHeight,
      overrideClass = _ref3.overrideClass,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref3, ["width", "height", "color", "bgColor", "hoverColor", "hoverBgColor", "children", "borderColor", "border", "borderSize", "minHeight", "lineHeight", "overrideClass"]);
  var classes = useStyles({
    width: width,
    height: height,
    color: color,
    bgColor: bgColor,
    hoverColor: hoverColor,
    hoverBgColor: hoverBgColor,
    border: border,
    borderColor: borderColor,
    borderSize: borderSize,
    lineHeight: lineHeight,
    minHeight: minHeight
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Button, (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.button, overrideClass)
  }, otherProps), children);
};

BaseButton.propTypes = {
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  minHeight: _propTypes["default"].number,
  color: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string,
  hoverBgColor: _propTypes["default"].string,
  border: _propTypes["default"].string,
  borderColor: _propTypes["default"].string,
  borderSize: _propTypes["default"].number,
  overrideClass: _propTypes["default"].string,
  children: _propTypes["default"].node
};
BaseButton.defaultProps = {
  width: 100,
  height: 48,
  lineHeight: undefined,
  minHeight: undefined,
  color: '',
  bgColor: '',
  hoverColor: '',
  hoverBgColor: '',
  children: '',
  border: undefined,
  borderColor: '',
  borderSize: 1,
  overrideClass: ''
};
var _default = BaseButton;
exports["default"] = _default;